/* global axios */
import ApiClient from '../ApiClient';

// T-133: taxa de recontato (de tudo que foi resolvido no período, quanto voltou).
class RecontatoAPI extends ApiClient {
  constructor() {
    super('fandata/recontato_relatorio', { accountScoped: true });
  }

  get({ since, until, janela } = {}) {
    return axios.get(this.url, { params: { since, until, janela } });
  }
}

export default new RecontatoAPI();
